module.exports = "/app/main/img/extra-guest-v2.f665cbc1.png";